import apiCalls from "../../config/apiCalls";
import Headers from "../../config/headers";
import { keyMapsMutation } from "../../helpers/storeKeys";
import LocalStorageFunc from "../../helpers/localStorageFunc";

export default {
  namespaced: true,
  state: {
    isLoadingTopTenBestsellerAPI: true,
  },
  mutations: {
    updateMultipleRecommendationData(state, payload) {
      const { sequenceSet, name } = payload?.apiPayload;
      let key = name ? name : "";
      if (sequenceSet) {
        key = key + "_" + sequenceSet;
      }

      state[key] = payload.response;
    },
    setIsLoadingLoadingTopTenBestsellerAPI(state, payload) {
      state.isLoadingTopTenBestsellerAPI = payload;
    },
  },
  actions: {
    getMultipleRecommendationData({ commit }, payload) {
      commit("setIsLoadingLoadingTopTenBestsellerAPI", true);
      apiCalls
        .GET_MULTIPLE_RECOMMENDATION_API({
          headers: Headers(),
          payload: {
            api: payload?.api,
            apiPayload: {
              ...payload?.apiPayload,
              storeId: LocalStorageFunc.storeId(),
            },
            payloadObj: payload.payloadObj,
          },
        })
        .then(function (response) {
          if (response?.data?.data) {
            commit("updateMultipleRecommendationData", {
              response: response?.data?.data,
              apiPayload: payload?.apiPayload,
            });
            if (response?.data?.data?.mediaBaseURL) {
              commit(
                keyMapsMutation.UPDATE_IMG_BASE_URL,
                response?.data?.data?.mediaBaseURL,
                {
                  root: true,
                }
              );
            }
            commit(
              keyMapsMutation.UPDATE_PRODUCTS_IN_STORE,
              response?.data?.data,
              {
                root: true,
              }
            );
            commit(
              keyMapsMutation.LOAD_CART_FROM_STORAGE_SERVICE,
              response?.data?.data,
              {
                root: true,
              }
            );
          }
        })
        .catch(function (error) {})
        .finally(function () {
          commit("setIsLoadingLoadingTopTenBestsellerAPI", false);
        });
    },
  },
};
